var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',{attrs:{"color":_vm.color}},[(_vm.store)?[_c('Icon',{attrs:{"icon":"store"}}),_vm._v(" "+_vm._s(_vm.store.name)+" ")]:[_vm._v("N/A")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }